import React, { useState, useEffect } from "react";
import PropTypes from 'prop-types'
// eslint-disable-next-line
import database from "../../firebase";
import styles from "./CreatePlaylist.module.css";

const CreatePlaylistComp = (props) => {
  // eslint-disable-next-line
  const [playlistName, setPlaylistName] = useState("");
  // eslint-disable-next-line
  const [playlistDescription, setPlaylistDescription] = useState("");
  // eslint-disable-next-line
  const [playlistTimePeriod, setPlaylistTimePeriod] = useState("");
  // eslint-disable-next-line
  const [playlistUpdates, setPlaylistUpdates] = useState(false);
  const [alreadyExistingPlaylists, setAlreadyExistingPlaylists] = useState([]);
  // eslint-disable-next-line
  const [topTracks, setTopTracks] = useState([]);

  useEffect(() => {
    let playlistsMultiDim = [];
    let playlistsOneDim = [];

    const getPlaylists = async (wichAccessToken, next) => {
      //get playlists
      const playlistsRes = await fetch(
        next || "https://api.spotify.com/v1/me/playlists?limit=50&offset=0",
        {
          method: "GET",
          headers: {
            Authorization: "Bearer " + wichAccessToken
          }
        }
      );
      let playlistsData = await playlistsRes.json();

      //determine if another call should be made
      if (playlistsData.next) {
        playlistsMultiDim.push(playlistsData.items);
        // console.log(playlistsOneDim, playlistsMultiDim)
        getPlaylists(wichAccessToken, playlistsData.next);
      } else if (!playlistsData.next) {
        playlistsMultiDim.push(playlistsData.items);
        for (const arr of playlistsMultiDim) {
          for (const item of arr) {
            playlistsOneDim.push(item);
          }
        }
        setAlreadyExistingPlaylists(playlistsOneDim);
      } else {
        console.error("error!");
      }
    };

    getPlaylists(sessionStorage.getItem("accessToken"));
  }, []);

  useEffect(() => {
    console.log(playlistName, playlistDescription, playlistTimePeriod, playlistUpdates)
  }, [playlistName, playlistDescription, playlistTimePeriod, playlistUpdates])

  const handleNameChange = e => {
    setPlaylistName(e.target.value)
  };

  const handleDescChange = e => {
    setPlaylistDescription(e.target.value)
  };

  const handleTimeChange = e => {
    setPlaylistTimePeriod(e.target.value)
  };

  const handleUpdateChange = e => {
    setPlaylistUpdates(e.target.checked)
  };

  const handleApply = () => {
    createTopPlaylist(
      playlistName,
      playlistTimePeriod,
      playlistDescription,
      playlistUpdates
    );
  };

  const createTopPlaylist = async (
    playlistNameParam,
    playlistTimePeriodParam,
    playlistDescParam,
    playlistUpdates
  ) => {
    //create DB reference
    const usersRef = database.ref("spotify/users");

    //get user data
    const userRes = await fetch("https://api.spotify.com/v1/me", {
      headers: { Authorization: "Bearer " + sessionStorage.getItem("accessToken") }
    });
    let userData = await userRes.json();

    usersRef.once("value", async snapshot => {
      if (
        alreadyExistingPlaylists !== [] &&
        !alreadyExistingPlaylists.includes(playlistNameParam)
      ) {
        if (
          playlistTimePeriodParam !== "" &&
          (playlistTimePeriodParam === "4weeks" ||
            playlistTimePeriodParam === "6months" ||
            playlistTimePeriodParam === "allTime")
        ) {
          const playlistTimePeriod =
            playlistTimePeriodParam === "allTime"
              ? "long_term"
              : playlistTimePeriodParam === "6months"
              ? "medium_term"
              : "short_term";

          //get top tracks
          const topTracksRes = await fetch(
            `https://api.spotify.com/v1/me/top/tracks?limit=50&offset=0&time_range=${playlistTimePeriod}`,
            {
              headers: { Authorization: "Bearer " + sessionStorage.getItem("accessToken") }
            }
          );
          let topTracksData = await topTracksRes.json();

          setTopTracks(topTracksData.items.map(track => track.uri))
          

          // create playlist
          const createPlaylistRes = await fetch(
            "https://api.spotify.com/v1/me/playlists",
            {
              body: `{"name": "${playlistNameParam} by dckjnls",
                        "description": "${playlistDescParam} do not change this part: ${playlistTimePeriodParam}"}`,
              headers: {
                Accept: "application/json",
                Authorization: "Bearer " + sessionStorage.getItem("accessToken"),
                "Content-Type": "application/json"
              },
              method: "POST"
            }
          );
          let createPlaylistData = await createPlaylistRes.json();

          //add top Tracks
          const addTracksRes = await fetch(
            "https://api.spotify.com/v1/playlists/" +
              createPlaylistData.id +
              "/tracks?uris=" +
              topTracks,
            {
              headers: {
                Accept: "application/json",
                Authorization: "Bearer " + sessionStorage.getItem("accessToken"),
                "Content-Type": "application/json"
              },
              method: "PUT"
            }
          );
          let addTracksData = await addTracksRes.json();

          console.log(addTracksData);

          if (playlistUpdates) {
            usersRef.once("value", snapshot => {
              const usersDBVal = Object.keys(snapshot.val());
              if (!usersDBVal.includes(userData.id)) {
                usersRef.update(
                  {
                    [userData.id]: {
                      refreshToken: sessionStorage.getItem("refreshToken"),
                      playlists: {
                        [playlistTimePeriodParam]: {
                          name: playlistNameParam,
                          id: createPlaylistData.id,
                          tracks: topTracks
                        }
                      }
                    }
                  },
                  err =>
                    err
                      ? console.error(err)
                      : console.log("everything went fine!")
                );
              } else {
                usersRef.child(userData.id).once("value", snapshot => {
                  if (snapshot.val()["playlists"] && !Object.keys(snapshot.val()["playlists"]).includes(playlistTimePeriodParam))
                  usersRef.child(`${userData.id}/playlists`).update(
                    {
                      [playlistTimePeriodParam]: {
                        name: playlistNameParam,
                        id: createPlaylistData.id,
                        tracks: topTracks
                      }
                    },
                    err =>
                      err
                        ? console.err(err)
                        : console.log(`${userData.id} updated`)
                  );
                })
              }
            });
          }
        }
      }
    });
  };



  return (
    <div className={styles.createPlaylistMain}>
      <form action="">
        <label htmlFor="playlistNameInput">Playlist Name</label>
        <br />
        <input
          type="text"
          value={playlistName}
          id="playlistNameInput"
          name="Playlist Name"
          required
          onChange={handleNameChange}
        />
        <br />

        <label htmlFor="playlistDescriptionInput">Description</label>
        <br />
        <textarea
          value={playlistDescription}
          name="playlistDescription"
          id="playlistDescriptionInput"
          cols="30"
          rows="5"
          onChange={handleDescChange}
        />
        <br />

        <label htmlFor="playlistPeriodSelection">period of time</label>
        <br />
        <select
          value={playlistTimePeriod}
          id="playlistPeriodSelection"
          required
          onChange={handleTimeChange}
        >
          <option value=""></option>
          <option value="4weeks">4 Weeks</option>
          <option value="6months">6 Months</option>
          <option value="allTime">All-Time</option>
        </select>
        <br />

        <input
          value={playlistUpdates}
          id="playlistUpdatesCheck"
          type="checkbox"
          onChange={handleUpdateChange}
        />
        <label htmlFor="playlistUpdatesCheck">
          weekly updates for playlist
        </label>
        <br />

        <button type="button" onClick={handleApply}>
          Apply
        </button>
      </form>
    </div>
  );
};

CreatePlaylistComp.propTypes = {

}

export default CreatePlaylistComp;
